<div class="reply-reminder-alert alert alert-info">
    <sb-inline-svg
        class="icon"
        style="padding: 0 0 3px 0"
        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Timer outlined icon.svg'">
    </sb-inline-svg
    >&nbsp;{{
        ('The reminder ends at' | translate) + (reminder.time | date: ' dd.MM.yyyy HH:mm') + ('. Click' | translate)
    }}
    <a class="pointer" (click)="removeReminderClick.emit()" translate>here</a>
    {{ 'to remove the reminder.' | translate }}
</div>
